import React from 'react';
import { Link } from 'react-router-dom';
import { Tab } from '@mui/material';


type LinkTabProps = {
    label: string;
    to: string;
    value: string,
}

const LinkTab = (props: LinkTabProps) => {
    return (
        <Tab
            component={Link}
            {...props}
        />
    );
}

export default LinkTab;
